import axios from 'axios';
import { useEffect, useState } from 'react';
import { BASE_URL } from '../../../insightConfig/insightConfig';
import Select from 'react-select'
import { Link } from 'react-router-dom';


const NeetDashboard = () => {
    const [orders, setOrders] = useState([]);
    const [selectedOrders, setSelectedOrders] = useState([]);
    const [selecteSection, setSelectedSection] = useState('All Sections');
    const [selectedOrder, setSelectedOrder] = useState({});
    // let attempedTests = selectedOrder.CompletedTests + 1;
    const [tests, setTests] = useState([]);
    const { Sn, OrderID, ExamType = "neet", Duration, Marks_per_Question, Negative_Marking, QuestionCount, Subject, TestCount, CompletedTests, QuestionsToBeAttempted, Attempt } = selectedOrder;

    useEffect(() => {
        const fetchData = async () => {
            const response = await axios.get(BASE_URL + "/neet/user/my-tests-orders");
            setOrders(response?.data?.data);
            setSelectedOrders(response?.data?.data);
        }
        fetchData()
    }, [])

    useEffect(() => {
        if (Sn) {
            setTests(Array.from({ length: TestCount }, (_, i) => i + 1));
        }
    }, [Sn])
    return (
        <>
            {
                !Sn ?
                    <div className="container-fluid px-2">
                        <div className="card shadow-sm">
                            {/* <div className="d-flex justify-content-between align-items-center">
                                <div className="w-25 bg-light">
                                    <Select
                                        id='select_test'
                                        value={{ value: selecteSection, label: selecteSection }}
                                        onChange={(selectedOption) => {
                                            setSelectedSection(selectedOption.value);
                                            if (selectedOption.value == 'All Sections') {
                                                setSelectedOrders(orders);
                                                return
                                            }
                                            setSelectedOrders(orders.filter((data) => data.ExamType == selectedOption.value));

                                        }
                                        }
                                        options={['All Sections', 'Section-IA', 'Section-II', 'Section-III']?.map((item) => ({ value: item, label: item }))}
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                width: '100%',
                                                backgroundColor: 'white',
                                                borderColor: '#17a2b8'
                                            })
                                        }}
                                    />
                                </div>
                                <div className="w-25 d-flex justify-content-end">
                                    <Link to={'/cuet'} className='btn btn-info text-light mt-1 me-1 fw-semibold' >Purchase Tests</Link>
                                </div>
                            </div> */}
                            <div className="card-body mt-0 pt-2">
                                <div className="table-responsive">
                                    <table className="table table-bordered text-center">
                                        <thead>
                                            <tr>
                                                <th colSpan="6" style={{ backgroundColor: "#ff2f00" }} className="text-white fs-6">YOUR NEET ORDERS</th>
                                            </tr>
                                            <tr className="bg-light">
                                                <th>S No.</th>
                                                <th>Subject</th>
                                                <th>No. of Tests Enrolled</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedOrders?.map((course, index) => (
                                                <tr key={index} className='p-0'>
                                                    <td>{index + 1}</td>
                                                    <td>{course.Subject}</td>
                                                    <td>{course.TestCount}</td>
                                                    <td><button className='btn btn-success btn-sm px-3' onClick={() => setSelectedOrder(course)}> Start</button> </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div> :
                    <div className='card p-2 pt-1 my-4 mx-2 shadow-lg'>
                        <div className="d-flex justify-content-between align-items-center p-2 py-1 bg-light border rounded shadow-sm">
                            <button className="btn btn-sm btn-outline-success" onClick={() => setSelectedOrder({})} >← Back</button>
                            <h2 className="mb-0 fs-5" style={{ color: 'rgb(183, 6, 6)', fontWeight: 600, letterSpacing: '0.5px', textShadow: '0 1px 1px rgba(0,0,0,0.1)', lineHeight: '1.2' }}>{Subject}</h2>
                            <span style={{ backgroundColor: "#6e1158" }} className="badge  text-white fs-6">Tests: {TestCount}</span>
                        </div>
                        {tests?.map((testData, index) => {
                            const testNumber = index + 1;
                            console.log(CompletedTests?.split(','));
                            let isAttempted = false;
                            let attemptCount = 0;
                            if (CompletedTests != '') {
                                isAttempted = testNumber <= CompletedTests?.split(',').length;
                                attemptCount = CompletedTests?.split(',')[testNumber - 1] || 0;
                            }

                            // console.log(attemptCount, Attempt, isAttempted);
                            return (
                                < div key={index} className="d-grid gap-1 m-1 test-togglebackground" >
                                    <button className="toggle-button py-1">
                                        <div className="text-nowrap me-2 fw-medium">
                                            Test-{index + 1}
                                        </div>
                                        <div className='toggleheadingContainer me-3'></div>
                                        <div className='toggleheadingContainer me-3'>

                                        </div>
                                        <div className="d-flex justify-content-end align-items-center gap-1 w-75">
                                            {
                                                Number(attemptCount) < Attempt && isAttempted &&
                                                < Link to={`/neet/online-exam/instructions`} state={{ testDetails: { ...selectedOrder, exam_type: ExamType, testNumber: index + 1, orderId: OrderID, Duration: Duration, marksPerQuestion: Marks_per_Question, negativeMarking: Negative_Marking, questionLimit: QuestionCount, questionsToBeAttempted: QuestionsToBeAttempted, reAttempt: true } }} className='list-group-item p-1 fw-bold bg-pureorange test-btn text-white w-50'>
                                                    REATTEMPT
                                                </Link >
                                            }
                                            < Link to={`/neet/online-exam/${isAttempted ? 'report' : 'instructions'}`} state={{ testDetails: { ...selectedOrder, exam_type: ExamType, testNumber: index + 1, orderId: OrderID, Duration: Duration, marksPerQuestion: Marks_per_Question, negativeMarking: Negative_Marking, questionLimit: QuestionCount, questionsToBeAttempted: QuestionsToBeAttempted } }} className='list-group-item p-1 fw-bold bg-pureorange test-btn text-white w-50'>
                                                {isAttempted ? "REPORT" : "START"}
                                            </Link >
                                        </div>

                                    </button>
                                </div>
                            )
                        }

                        )}
                    </div >
            }

        </>


    )
}

export default NeetDashboard